<template>
  <div>
    <transition name="ani-slide-in">
      <component :is="activeComponent" v-if="!$auth.loading && !$workSessions.loading"></component>
    </transition>
  </div>
</template>

<script>

import ClientProjectSettings from "../components/modules/settings/ClientProjectSettings";
import ReportIncidentComponent from "../components/modules/reportIncident/ReportIncidentComponent"
import CapSaveStateInvalidatorMixin from "../mixins/capSettings/CapSaveStateInvalidatorMixin";
import authMixin from "@/auth/sanctum/mixins/authMixin";
import WSReliantComponentMixin from "@/workSessions/mixins/WSReliantComponentMixin";


export default {
  name: "ReportIncident",
  components: {
    cPSettings: ClientProjectSettings,
    rIComponent: ReportIncidentComponent
  },
  computed: {
    activeComponent() {
      if (this.hasValidWorkSession || this.$store.state.capsSaveValidated) {
        return 'rIComponent'
      }
      return 'cPSettings'
    }
  },
  mixins: [CapSaveStateInvalidatorMixin, authMixin, WSReliantComponentMixin],
  created() {
    //DISPATCH LOCATION GRAB
    this.$store.dispatch('getUserLocation');
  }
}
</script>